export default "__VITE_ASSET__2agQ5UEv__"